import React, { Fragment } from "react";
import { connect } from "react-redux";
import PageTitle from "../../components/pagetitle/PageTitle";
import Navbar from "../../components/Navbar/Navbar";
import CheckoutSection from "../../components/CheckoutSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { RootState } from "../../store/reducers/rootReducers";
import { ProductItem } from "../../store/actions/action";

// 🧾 Define Props
interface CheckoutPageProps {
  cartList: ProductItem[];
  symbol: string;
}

const CheckoutPage: React.FC<CheckoutPageProps> = ({ cartList, symbol }) => {
  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle="Checkout" pagesub="Checkout" />
      <CheckoutSection cartList={cartList} />
      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

// 🧠 Map Redux State to Props
const mapStateToProps = (state: RootState) => ({
  cartList: state.cartList.cart,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps)(CheckoutPage);
